<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    :title="$l('dialog_title_setCostRate') || '变更费率'"
    show-close
    width="350px"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    v-el-dialog-drag
    append-to-body
    top="15vh"
  >
    <Main
      ref="main"
      :pdCostsOrderCode="pdCostsOrderCode"
      @reload="$emit('reload')"
      @close="close()"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.main.save()">
        {{ $l('btn_set') || '变更' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    pdCostsOrderCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
